<template>
  <div class="inner">
    <div class="page_con">
  <!--    <div class="empty_wrap">
      <div class="empty red">
        <span>수료증은 PC 홈페이지 에서만<br>출력 가능합니다.</span>
      </div>
      </div>-->
      <div class="table_toggle">
        <div class="btn_wrap">
          <button class="toggle_btn" :class="{'on': onlineType === 1}" @click="onlineType = 1"><span>온라인 교육</span>
          </button><!--'선택 시: on'-->
          <button class="toggle_btn" :class="{'on' : onlineType === 2}" @click="onlineType = 2"><span>집합 교육</span>
          </button>
        </div>
      </div>
      <edu-done-list :eduType="eduType" :items="list" :pageInfo="pageInfo" :isOnline="onlineType === 1" @print="fnPrint"/>
    </div>
  </div>
</template>

<script>
import EduDoneList from '@/components/pages/edu/done/list'
export default {
  name: 'edu-done-index',
  components: {
    EduDoneList
  },
  computed: {
    eduType: function() {
      return this.$store.getters['education/getEduType']
    }
  },
  data() {
    return {
      currentIndex: 1,
      onlineType: 1,
      params: {
        page: 1,
        limit: 10,
        isEnd: 1
      },
      list: [],
      pageInfo: {}
    }
  },
  watch: {
    onlineType: function() {
      this.fetchData()
    }
  },
  async created() {
    let res = {}
    if (this.onlineType === 1) {
      res = await this.$OnlineClassSvc.fetchUserOnlineClass(this.params)
      console.log('res', res)
      this.isOnline = true
    } else if (this.onlineType === 2) {
      res = await this.$OfflineEduSvc.fetchUserOfflineClass(this.params)
      this.isOnline = false
    }
    if (res.code === 1) {
      this.list = res.entity.list
      this.pageInfo = res.entity.pageInfo
    }
  },
  methods: {
    fnPrint: function(item) {
      console.log('item {}', item)
      item.onlineType = this.onlineType
      this.$store.commit('education/setPrintData', item)
      this.$router.push('/edu/completed/certification')
      // this.$store.commit('layout/setModalAlert', { data: { item }, modalAlertName: this.$modalAlertNames.RECEIPT })
    },
    fetchData: async function(page) {
      this.params.page = page
      let res = {}
      if (this.onlineType === 1) {
        res = await this.$OnlineClassSvc.fetchUserOnlineClass(this.params)
      } else if (this.onlineType === 2) {
        res = await this.$OfflineEduSvc.fetchUserOfflineClass(this.params)
      }
      if (res.code === 1) {
        this.list = res.entity.list
        this.pageInfo = res.entity.pageInfo
      }
    },
  }
}
</script>

<style scoped>

</style>
